export default __webpack_public_path__ + "static/media/loader-icon.a5fc262d.gif";